module.exports = __webpack_public_path__ + "static/img/ic_one.cf5f756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ic_one.png
// module id = 427
// module chunks = 1